/**
 * Custom SDK error class
 */
export class SDKError extends Error {
  constructor(message: string, public status?: number, public code?: string, public data?: any) {
    super(message);
    this.name = 'SDKError';
    Object.setPrototypeOf(this, SDKError.prototype);
  }
}
